import {css} from 'emotion';

export const nonArticleContentStyle = css`
  font-size: 1rem;
`;
